import React, { useState } from 'react';

import PropTypes from 'prop-types';
import InputGroup from '@tds/community-input-group';
import SearchWrapper from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import request from '../../../../utils/request';

const SearchBar = ({ setOrders, fetchOrders }) => {
  const localigedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { searchHintIot, searchLabel }
  } = localigedStrings;
  const [searchString, setSearchString] = useState();

  const filterOrders = async (clearSearch = false) => {
    if (clearSearch) {
      fetchOrders();
      return;
    }

    if (searchString) {
      const response = await request.get(`/orders?type=IOT&q=${searchString}`);
      if (response) setOrders(response);
    }
  };

  return (
    <SearchWrapper>
      <InputGroup
        label={searchLabel}
        hint={searchHintIot}
        defaultValue={searchString}
        onClearButtonClick={() => {
          setSearchString('');
          filterOrders(true);
        }}
        onChange={e => setSearchString(e.target.value)}
        onButtonClick={() => filterOrders()}
        onKeyDown={e => {
          if (e.key === 'Enter') filterOrders();
        }}
      />
    </SearchWrapper>
  );
};

SearchBar.propTypes = {
  setOrders: PropTypes.func.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default SearchBar;
